import Button from "../../../../../common/components/button";
import TableName from "../../../../components/common/tableName";
import Input from "../../../../components/common/input";
import SelectBox from "../../../../components/common/selectBox";
import { useGetWordCategory } from "../../../../../common/hooks/console/management/word/useGetWordCategory";
import { useState } from "react";
import useToastStore from "../../../../store/useToastStore";
import { usePostWord } from "../../../../../common/hooks/console/management/word/usePostWord";
import Spinner from "../../../../../common/components/spinner";

const NewWord = ({ onWordCreated }: { onWordCreated: (wordIdx: number) => void }) => {
    const { addToast } = useToastStore();

    const [selectedCategory, setSelectedCategory] = useState<string>("");
    const [wreathWord, setWreathWord] = useState<string>("");
    const [searchWord, setSearchWord] = useState<string>("");
    const [categoryError, setCategoryError] = useState<boolean>(false);
    const [wreathWordError, setWreathWordError] = useState<boolean>(false);

    const { mutate, isPending } = usePostWord(wordIdx => {
        addToast({
            type: "success",
            message: "경조사어가 신규등록되었습니다.",
        });
        onWordCreated(wordIdx);
    });

    const handleSave = () => {
        let hasError = false;
        if (!selectedCategory) {
            setCategoryError(true);
            hasError = true;
        }
        if (!wreathWord.trim()) {
            setWreathWordError(true);
            hasError = true;
        }
        if (hasError) return;

        mutate({
            event_category_idx: Number(selectedCategory),
            wreath_word: wreathWord,
            search_word: searchWord,
        });
    };

    const handleCancel = () => {
        setSelectedCategory("");
        setWreathWord("");
        setSearchWord("");
        setCategoryError(false);
        setWreathWordError(false);
    };

    const { data: categoryData } = useGetWordCategory();
    const categoryOptions = categoryData
        ? categoryData.map(cat => ({
              value: cat.event_category_idx.toString(),
              label: cat.event_name,
          }))
        : [];

    return (
        <div className="bg-gray6 h-full overflow-y-auto">
            {isPending && <Spinner />}

            <div className="shadow-custom bg-white gap-5 flex flex-col px-3 py-5 rounded-xl">
                <p className="text-xl font-bold">경조사어 등록</p>
                <div className="border-t-2 border-gray2">
                    <div className="flex items-center border-b border-gray4">
                        <TableName className="h-12" required>
                            카테고리
                        </TableName>
                        <SelectBox
                            full
                            className="w-full bg-white px-2"
                            placeholder="카테고리 선택"
                            options={categoryOptions}
                            value={selectedCategory}
                            onChange={value => {
                                setSelectedCategory(value);
                                setCategoryError(false);
                            }}
                            status={categoryError ? "error" : undefined}
                        />
                    </div>
                    <div className="flex items-center border-b border-gray4">
                        <TableName className="h-12" required>
                            경조사어
                        </TableName>
                        <Input
                            maxLength={30}
                            placeholder="30자"
                            className="w-full px-2"
                            value={wreathWord}
                            status={wreathWordError ? "error" : undefined}
                            onChange={e => {
                                setWreathWord(e.target.value);
                                setWreathWordError(false);
                            }}
                        />
                    </div>
                    <div className="flex items-center border-b border-gray4">
                        <TableName className="h-12">검색어</TableName>
                        <Input
                            maxLength={30}
                            placeholder="30자"
                            className="w-full px-2"
                            value={searchWord}
                            onChange={e => setSearchWord(e.target.value)}
                        />
                    </div>
                </div>
                <div className="flex w-full gap-2">
                    <Button className="w-full" size="L" onClick={handleCancel}>
                        취소
                    </Button>
                    <Button status="regist" className="w-full" size="L" onClick={handleSave}>
                        저장
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default NewWord;
